import styled from 'styled-components';
import Select from 'react-select';
import { BREAKPOINTS } from 'constants/breakpoints';

import { colours } from 'themes/default';

const MOBILE_BREAKPOINT = `${BREAKPOINTS.lg.max}px`;

export const StyledReactSelect = styled(Select)`
  &.react-select-container {
    width: ${({ width }) => width || 'auto'};
    margin-left: ${({ ml }) => ml || '0'};
    margin-right: ${({ mr }) => mr || '0'};
    margin-top: ${({ mt }) => mt || '0'};
    margin-bottom: ${({ mt }) => mt || '0'};

    .react-select__control {
      height: 100%;
      min-height: ${({ height }) => height || '32px'};
      max-height: ${({ height }) => height || '32px'};
      cursor: text;
      border: 1px solid ${colours.Shades.TintBlue10};
      display: flex;
      font: ${({ theme }) => theme.font};
      background-color: ${colours.Greyscale.White};
      border-radius: 0.35em;

      &.react-select__control--is-focused {
        box-shadow: 0 0 0 1px ${colours.Core.CoreNavy};
        outline: none;
      }
    }

    .react-select__value-container {
      padding: 0 8px;
    }

    .react-select__single-value {
      color: ${colours.Core.CoreNavy};
    }

    .react-select__input-container {
      margin: 0 2px;
      padding-bottom: 0;
      padding-top: 0;
    }

    .react-select__indicator-separator {
      margin-top: 4px;
      margin-bottom: 4px;
      background-color: ${colours.Shades.TintBlue10};
    }

    .react-select__dropdown-indicator {
      padding: 0 4px;
      color: ${colours.Core.CoreNavy};
    }

    .react-select__option {
      cursor: pointer;
      color: ${colours.Core.CoreNavy};
      padding: 0.6em 0.8em;
      background-color: ${colours.Greyscale.White};

      &.react-select__option--is-focused {
        background-color: ${colours.Greyscale.MistGrey};
      }

      &.react-select__option--is-selected {
        background-color: ${colours.Shades.TintBlue10};
      }
    }

    @media (max-width: ${MOBILE_BREAKPOINT}) {
      &.email-language {
        .react-select__menu {
          top: -175%;
        }
      }
    }
  }
`;
